export default [
    {
        path: '/course/',
        component: (resolve) => require(['@/components/course/Index'], resolve),
        meta: {
            title: '课程列表'
        }
    },
    {
        path: '/course/detail',
        component: (resolve) => require(['@/components/course/Detail'], resolve),
        meta: {
            default: '/course/',
            multiple: true,
            exclude: 'pageBack'
        }
    },
     {
        path: '/course/live-room-play-detail',
        component: (resolve) => require(['@/components/course/LiveRoomPlayDetail'], resolve),
        meta: {
            title: '直播详情',
            default: '/my/study-center/course',
            multiple: true,
            loginIn: true,
        }
    },
    {
        path: '/course/video-play',
        component: (resolve) => require(['@/components/course/VideoPlay'], resolve),
        meta: {
            title: '点播详情',
            default: '/my/study-center/course',
            multiple: true,
            exclude: 'pageBack'
        }
    },
    {
        path: '/course/order',
        component: (resolve) => require(['@/components/course/Order'], resolve),
        meta: {
            title: '课程订单',
        }
    },

    {
        path: '/course/course-chapter',
        component: (resolve) => require(['@/components/course/CourseChapter'], resolve),
        meta: {
            title: '课程目录',
        }
    },

    {
        path: '/course/class_com',
        component: (resolve) => require(['@/components/course/ClassCom'], resolve),
        meta: {
            title: '课程评价',
        }
    },

    {
        path: '/course/comment',
        component: (resolve) => require(['@/components/course/Comment'], resolve),
    },
    {
        path: '/course/teacher',
        component: (resolve) => require(['@/components/course/Teacher'], resolve),
    },
    {
        path: '/course/live-msg',
        component: (resolve) => require(['@/components/course/LiveMsg'], resolve),
    },
    {
        path: '/course/pay-finish',
        component: (resolve) => require(['@/components/course/PayFinish'], resolve),
        meta: {
            title: '购买成功',
        }
    },
    {
        path: '/course/share',
        component: (resolve) => require(['@/components/course/Share'], resolve),
    },
    {
        path: '/course/preview',
        component: (resolve) => require(['@/components/course/Preview'], resolve),
        meta: {
            title: '资料预览',
            multiple: true,
            exclude:'pageBack'
        }
    },
    {
        path: '/course/index2',
        component: (resolve) => require(['@/components/course/Index2'], resolve),
        meta: {
            title: '课程列表'
        }
    },
    {
        path: '/course/course_list',
        component: (resolve) => require(['@/components/course/CourseList'], resolve),
        meta: {
            title: '课程选座列表',
            default: '/my/study-center/order',
            multiple: true,
            exclude: 'pageBack'
        }
    },
    {
        path: '/course/class_list',
        component: (resolve) => require(['@/components/course/ClassList'], resolve),
        meta: {
            title: '选择班级列表',
            default: '/course/pay-finish',
            multiple: true,
            exclude: 'pageBack'
        }
    },
    {
        path: '/course/class_room',
        component: (resolve) => require(['@/components/course/ClassRoom'], resolve),
        meta: {
            title: '教室占座页面',
            default: '/course/class_list',
            multiple: true,
            exclude: 'pageBack'
        }
    },
    {
        path: '/course/order_details',
        component: (resolve) => require(['@/components/course/OrderDetails'], resolve),
        meta: {
            title: '面授订单详情',
            default: '/my/study-center/order',
            multiple: true,
        }
    },
    {
        path: '/course/index2',
        component: (resolve) => require(['@/components/course/Index2'], resolve),
        name:'courseIndex2',
        meta: {
            title: '课程列表2'
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/course.js